import { textFormatting } from '@yola/ws-sdk';
import customUI from 'src/js/modules/custom-ui';
import constants from './constants';
import controls from './controls';
import helpers from './helpers';
import AiRewriteTextContainer from './containers/ai-rewrite-text-container';
import AiWriteTextContainer from './containers/ai-write-text-container';

const {
  linkControl,
  listBulletControl,
  listNumberControl,
  elementTypeControl,
  alignControl,
  clearControl,
  textColorControl,
  insertImageControl,
  fontSizeControl,
  aiWriteTextControl,
  aiRewriteTextControl,
  aiRewriteCollapsedTextControl,
  textFormattingControl,
  textIndentControl,
  textOutdentControl,
} = controls;
const { afterViewLoad, isSupportedColorOptions, removeDynamicAttributes } = helpers;
const { addRelatedClassesToElement, removeRelatedClassesFromElement } = textFormatting.helpers;

const controlList = [
  textFormattingControl,
  linkControl,
  insertImageControl,
  listBulletControl,
  listNumberControl,
  alignControl,
  clearControl,
  elementTypeControl,
  fontSizeControl,
  aiWriteTextControl,
  aiRewriteTextControl,
  aiRewriteCollapsedTextControl,
  textIndentControl,
  textOutdentControl,
];

if (isSupportedColorOptions()) {
  controlList.splice(1, 0, textColorControl);
}

const extension = {
  injections: {
    afterElementInsert: addRelatedClassesToElement,
    afterElementSynchronize: removeRelatedClassesFromElement,
    afterViewLoad,
  },
  hooks: {
    afterBlurFocusedElement: addRelatedClassesToElement,
    beforeBlurFocusedElement: removeRelatedClassesFromElement,
    beforeSynchronizeStaticElement: (oldElement, newElement) => {
      removeDynamicAttributes(newElement);
    },
  },
  slug: constants.common.SLUG,
  title: 'Text Formatting Extension',
  description: 'Extension for editing text',
  defaults: {
    textContainer: 'ws-text',

    textFormattingRestrictedParentsSelector: '',
    textFormattingQuerySelector: '*',

    textColorRestrictedParentsSelector: '',
    textColorQuerySelector: '*',

    linkQuerySelector: 'a',
    linkRestrictedParentsSelector: '',
    linkDeleteButtonQuerySelector: '*',

    bulletListQuerySelector: 'p',
    bulletListRestrictedParentsSelector: '',

    numberedListQuerySelector: 'p',
    numberedListRestrictedParentsSelector: '',

    clearRestrictedParentsSelector: '',
    clearQuerySelector: '*',

    alignTextRestrictedParentsSelector: 'li',
    alignTextQuerySelector: '*',

    insertImageRestrictedParentsSelector: '',
    insertImageQuerySelector: '*',

    elementTypeRestrictedParentsSelector: '',

    fontSizeRestrictedParentsSelector: '',

    textIndentRestrictedParentsSelector: '',
  },
  ui: {
    control: controlList,
  },
  init() {
    customUI.operations.register(customUI.customUiTypes.AI_REWRITE, AiRewriteTextContainer, {
      controlShowingOnScroll: true,
    });
    customUI.operations.register(customUI.customUiTypes.AI_WRITE, AiWriteTextContainer, {
      controlShowingOnScroll: true,
    });
  },
};

export default extension;
